'use client'

import { useEffect, useRef } from 'react'

declare global {
  interface Window {
    adsbygoogle?: Record<string, unknown>[]
  }
}

const heights = {
  banner: 'min-h-[100px] sm:min-h-[120px]',
  inArticle: 'min-h-[180px] sm:min-h-[220px]',
}

interface AdSlotProps {
  slot?: string
  placement?: keyof typeof heights
  className?: string
}

export default function AdSlot({ slot, placement = 'banner', className = '' }: AdSlotProps) {
  const client = process.env.NEXT_PUBLIC_GOOGLE_ADSENSE_CLIENT
  const initialized = useRef(false)
  const enabled = Boolean(client && slot)

  useEffect(() => {
    if (!enabled || initialized.current) return

    try {
      window.adsbygoogle = window.adsbygoogle || []
      window.adsbygoogle.push({})
      initialized.current = true
    } catch {
      // Ad blockers can prevent the provider script from initializing.
    }
  }, [enabled])

  if (!enabled) return null

  return (
    <aside
      className={`mx-auto w-full max-w-5xl border-y border-white/10 py-5 ${className}`}
      aria-label="Advertisement"
    >
      <p className="mb-3 text-center text-[10px] font-bold tracking-[0.18em] text-white/40 uppercase">
        Advertisement
      </p>
      <div className={`flex w-full items-center justify-center ${heights[placement]}`}>
        <ins
          className="adsbygoogle block w-full"
          data-ad-client={client}
          data-ad-slot={slot}
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </div>
    </aside>
  )
}
